import $ from 'jquery'

import logo from './logo/logo'
import lang from './lang/lang'
import user from './user/user'
import feedback from './feedback/feedback'
import refresh from './refresh/refresh'
import settings from './settings/settings'

export default function(o){

  var div =
    $('<div>')
    .css({
      position: 'fixed',
      left: 0,
      rigtht: 0,
      top: 0,
      height: '34px',
      width: '100%',
    })
    .append([
      logo(o),
      user(o),
      feedback(o),
      lang(o),
      settings(o),
      refresh(o),
    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/topbar/topbar.js